import { getAxiosInstance } from "../../../../api";

export const getEstimate = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/back-office-billing/old-certificate/generate-estimate`,
      body
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const updateOldCertificateStocks = async () => {
  try {
    const api = await getAxiosInstance();
    const res = await api.get(
      `/back-office-billing/old-certificate/update-stocks`
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const getEstimateType = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post('/back-office-billing/stock-services-reissue-list',
    body
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
